import { http } from '../../../../api/http';
import type {
  GuiaProduccion,
  GuiaProduccionFormData,
  ArticuloProduccion,
  EstadoGuiaProduccion,
  GuiaProduccionDetailResponse
} from '../types';

export class GuiaProduccionService {
  private static readonly BASE_URL = '/produccion/Guia';

  static async getAll(page: number = 1, pageSize: number = 10): Promise<{ data: GuiaProduccion[]; totalCount: number }> {
    try {
      const response = await http.get(`${this.BASE_URL}/guias-produccion?page=${page}&pageSize=${pageSize}`);

      // If the API returns an array directly, wrap it in the expected structure
      if (Array.isArray(response.data)) {
        return {
          data: response.data,
          totalCount: response.data.length
        };
      }

      // If the API returns the expected structure, use it
      return response.data;
    } catch (error) {
      console.error('Error fetching guias produccion:', error);
      throw error;
    }
  }

  static async getById(id: number): Promise<GuiaProduccionDetailResponse> {
    try {
      const response = await http.get(`${this.BASE_URL}/guias-produccion/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching guia produccion with id ${id}:`, error);
      throw error;
    }
  }

  static async save(formData: GuiaProduccionFormData, productos: ArticuloProduccion[]): Promise<number> {
    try {
      const payload = {
        id: formData.id,
        idGuiaRecepcion: formData.idGuiaMateriaPrima,
        idGuiaRecepcionDetalle: formData.idDetalleMateriaPrima,
        observaciones: formData.observaciones,
        notas: formData.notas,
        detalles: productos.map(p => ({
          idArticulo: p.idArticulo,
          cantidad: p.cantidad,
          coeficiente: p.coeficiente,
          esDevueltoInterno: p.devolucionInterna || false,
          esDevueltoExterno: p.devolucionProveedor || false,
          cantidadDevolucion: p.devolucionProveedor ? (p.cantidadDevolucion ?? p.cantidad) : null
        }))
      };

      const response = await http.post(`${this.BASE_URL}/guias-produccion`, payload);

      return response.data;
    } catch (error) {
      console.error('Error saving guia produccion:', error);
      throw error;
    }
  }

  static async updateEstado(id: number, estado: EstadoGuiaProduccion): Promise<void> {
    try {
      await http.patch(`${this.BASE_URL}/guias-produccion/${id}/estado`, estado);
    } catch (error) {
      console.error(`Error updating estado of guia produccion with id ${id}:`, error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/guias-produccion/${id}`);
    } catch (error) {
      console.error(`Error deleting guia produccion with id ${id}:`, error);
      throw error;
    }
  }
}
